import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { PoliticaVinculacion } from "../_models/politica-vinculacion";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaDescarteVinculacion} from '../_models/politica-descarte-vinculacion';
import {PoliticaAlertaVinculacion} from '../_models/politica-alerta-vinculacion';

@Injectable({
  providedIn: "root",
})
export class PoliticasAlertasVinculacionesService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasAlertasVinculaciones";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticasVinculaciones() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaAlertaVinculacion[]));
  }

  listadoPoliticasVinculacionesHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaAlertaVinculacion[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaAlertaVinculacion));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaAlertaVinculacion[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaAlertaVinculacion[]));
  }

  crear(regCrear: PoliticaAlertaVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaAlertaVinculacion));
  }

  actualizar(regActualizar: PoliticaAlertaVinculacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaAlertaVinculacion));
  }

  bulk(registros: PoliticaAlertaVinculacion[]) {
    registros.map((s: PoliticaAlertaVinculacion) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaAlertaVinculacion[]));
  }
}
